import { Component, OnInit, Input } from '@angular/core';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { MessageService, MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
@Component({
  selector: 'app-bons-travail-view',
  templateUrl: './bons-travail-view.component.html'
})
export class BonsTravailViewComponent implements OnInit {
  tabs: MenuItem[] = [
    { label: 'Soumissions', routerLink: ['/mecanique/soumissions'] },
    { label: 'Bons de travail', routerLink: ['/mecanique/bontravails'] },
    { label: 'Analyses', routerLink: ['/mecanique/analyses'] }
  ];
  
  constructor(
    private bonTravailService: BonTravailService,
    private messageService: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {

  }
}
